import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  /* Named colour palette. Without [color] the icon inherits currentColor (its normal
     styling); a [color] value takes precedence. Defined here, in the component's own
     styles, so it works inside shadow DOM where global .text-* utilities cannot reach.
     Values mirror the app's .text-* utilities so existing usages keep their colours. */
  :host([color='red']) {
    color: var(--webmodule-color-red-500);
  }
  :host([color='blue']) {
    color: var(--webmodule-color-blue-500);
  }
  :host([color='primary']) {
    color: var(--webmodule-color-primary);
  }
  :host([color='cyan']) {
    color: var(--webmodule-color-cyan-500);
  }
  :host([color='green']) {
    color: var(--webmodule-color-green-500);
  }
  :host([color='yellow']) {
    color: var(--webmodule-color-yellow-500);
  }
  :host([color='black']) {
    color: var(--webmodule-color-neutral-1000);
  }
  :host([color='white']) {
    color: var(--webmodule-color-neutral-0);
  }
  :host([color='gray']) {
    color: var(--webmodule-color-neutral-500);
  }
`;
